const validate = (value, args) => {
  let regex = /[áàâäéèêëíìîïóòôöúùûüýÿç]+/
  return !regex.test(value.toLowerCase())
}

export default {
  validate,
  getMessage: (field, args) => {
    return 'The accents are not allowed'
  }
}
